export default "__VITE_ASSET__coxlV_op__"